<template>
  <div class="min-height-for-section w-100 pt-livetv">
    <div class="px-0 px-md-4 container-fluid main-list-wrapper">
      <div class="main-list-section d-flex justify-content-center flex-column">
        <VodMasthead />

        <!-- ads -->
        <div class="w-100">
          <billboardBannerTop v-if="desktop"></billboardBannerTop>
          <mrecBannerTop v-if="mobile"></mrecBannerTop>
        </div>

        <CategoryCarousel :obj="categories" :cat_id="categories_id" />

        <div
          class="w-100 px-2 my-4"
          v-for="(items, index) in categories_id"
          :key="'cat_id' + items"
        >
          <VodRailsLandscapeNew
            :cat_id="items"
            :datasource="'vod'"
            :cat="convertStringToLower(categories[index].replace(/\s/g, ''))"
            :title="categories[index]"
            v-if="index !== 7"
          />
          <div class="w-100" v-if="index == 4">
            <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
            <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle>
          </div>
        </div>

        <!-- ads -->
        <!-- <billboardBannerMiddle v-if="desktop"></billboardBannerMiddle>
      <mrecBannerMiddle v-if="mobile"></mrecBannerMiddle> -->

        <!-- ads bottom -->
        <billboardbannerbottom v-if="desktop"></billboardbannerbottom>
        <mrecbannerbottom v-if="mobile"></mrecbannerbottom>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import noimage from "../assets/noimage.png";
import BreadCrumbsHeader from "@/components/common/breadCrumbsHeader.vue";
// ads
import billboardBannerTop from "../components/ads/v2/vod/billboardBannerTop.vue";
import mrecBannerTop from "../components/ads/v2/vod/mrecBannerTop.vue";
import billboardBannerMiddle from "../components/ads/v2/vod/billboardBannerMiddle.vue";
import mrecBannerMiddle from "../components/ads/v2/vod/mrecBannerMiddle.vue";
import BillboardBannerBottom from "../components/ads/v2/vod/billboardBannerBottom.vue";
import MrecBannerBottom from "../components/ads/v2/vod/mrecBannerBottom.vue";
import VodMasthead from "../components/carousel/vodMasthead.vue";
import CategoryCarousel from "../components/categoryCarousel.vue";
// import VodCovidrails from "../components/carousel/vod/vodCovidrails.vue";
// import VodCovidPreventionRails from "../components/carousel/vod/vodCovidPreventionRails.vue";
import VodRailsLandscapeNew from "../components/rails/vod_rails_landscape_new.vue";
export default {
  data: function() {
    return {
      vod: [],
      vod_mnn: [],
      vod_each: [],
      news: [],
      specials: [],
      trending: [],
      vod_episodes: [],
      noimage: noimage,
      mnnlink: "/play?scheme=205&p_type=true&id=1387&eps_id=",
      SpecialRailsId: "1387",
      SpecialRailsTitle: "COVID-19: MOH Press Conference",
      showvod_mnn: true,
      categories: [
        // "Covid-19",
        "Featured",
        // "News",
        "Exclusives",
        "Catch-Up",
        // "Documentary",
        "Drama",
        "Nostalgia",
        "Entertainment",
        "Magazine",
        "Education",
        "Religious",
        "Variety",
      ],
      categories_id: [
        // "846",
        "943", //kt sini festival
        // "212",
        "716",
        "746",
        // "703",
        "728",
        "749",
        "717",
        "715",
        "740",
        "718",
        "726",
      ],
      tablet: false,
      mobile: false,
      desktop: false,
    };
  },
  components: {
    billboardBannerTop: billboardBannerTop,
    mrecBannerTop: mrecBannerTop,
    billboardBannerMiddle: billboardBannerMiddle,
    mrecBannerMiddle: mrecBannerMiddle,
    billboardbannerbottom: BillboardBannerBottom,
    mrecbannerbottom: MrecBannerBottom,
    BreadCrumbsHeader,
    VodMasthead,
    CategoryCarousel,
    // VodCovidrails,
    VodRailsLandscapeNew,
    // VodCovidPreventionRails,
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          768: {
            items: 2,
            stagePadding: 0,
            loop: false,
          },
          991: {
            items: 5,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    installTrendingOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        margin: 10,
        responsiveClass: true,
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: true,
            stagePadding: 0,
          },
          600: {
            items: 2,
            nav: true,
            stagePadding: 0,
          },
          991: {
            items: 3,
            stagePadding: 0,
            loop: false,
          },
        },
      });
    },
    imgFiltering(item) {
      var imgurl;
      //check if
      var checkThumbnail =
        item.data && item.data.images && item.data.images.thumbnail;
      var checkTitle = item.data && item.data.images && item.data.images.title;

      if (checkThumbnail) {
        imgurl =
          "https://rtb-images.glueapi.io/500x0/" +
          item.data.images.thumbnail.path;
      } else {
        if (checkTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/500x0/" +
            item.data.images.title.path;
        } else {
          imgurl =
            "https://cdn-rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },

    goTo(link) {
      this.$router.push(link);
    },
    goToBanner(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema, check;
      var id = item.id;
      var title = item.data.title;

      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      }

      return link;
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    filterBasedOnCategory() {
      var obj = this.vod;
      var categories = this.categories;
      var each = {};
      // this.vod_each;
      obj.forEach((items) => {
        var content_type = items.data.content_type;

        if (content_type.length != 0) {
          content_type.forEach((items_cat) => {
            for (var i = 0; i < categories.length; i++) {
              if (
                items_cat.title.en_US === categories[i] ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i]) ||
                items_cat.title.en_US ===
                  this.convertStringToLower(categories[i].replace(/\s/g, ""))
              ) {
                // console.log(this.convertStringToLower(categories[i].replace(/\s/g, "")));
                if (
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ]
                ) {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ].push(items);
                } else {
                  each[
                    this.convertStringToLower(categories[i].replace(/\s/g, ""))
                  ] = [items];
                }
              }
            }
          });
        }
      });
      this.vod_each.push(each);
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    initializepageview() {
      var self = this;
      // console.log(this.$route.path);
      $.ajax({
        type: "POST",
        url: "https://rtb.glueapi.io/report/page-view",
        contentType: "application/json",
        data: JSON.stringify({
          href: this.$route.path,
          title: "vod",
          site: "RTBGo",
        }),
        dataType: "json",
        success: function(data) {
          // console.log(data);
        },
        failure: function(errMsg) {
          console.log(errMsg);
        },
      });
    },
    deviceCheck() {
      if (this.$device.ipad) {
        this.tablet = true;
      } else if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
  },

  mounted() {
    this.deviceCheck();
    if (!this.$route.params.id) {
      setTimeout(
        function() {
          this.initializepageview();
        }.bind(this),
        700
      );
    }
  },
};
</script>

<style scoped>
.main-list-wrapper {
  max-width: 100%;
}
.main-list-section {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.pt-livetv {
  padding: 20px 0 80px;
}
.breadCrumbsWrapper {
  padding: 30px;
}

@media only screen and (max-width: 992px) {
  /* .main-list-section {
    overflow: unset;
  } */
}

@media only screen and (max-width: 768px) {
  .main-list-wrapper {
    margin-top: 24px;
    margin-bottom: 24px !important;
  }

  .main-list-section {
    overflow: unset;
    margin: -4% auto 0;
  }

  .pt-livetv {
    padding: 8px 0 0;
    overflow: hidden;
  }
  .breadCrumbsWrapper {
    padding: 16px;
  }
}
</style>
